// Projects / Case studies source of truth.
// To add a new project, append to PROJECTS below. Each project has a slug that
// becomes the URL: /projects/{slug}
//
// NOTE: The `gallery` images for Design Mumbai 2025 are luxury biophilic
// placeholders from Unsplash. Replace them with the actual event photos as
// soon as they're supplied (Google Photos does not permit hotlinking, so the
// images need to be self-hosted or served from a public CDN / Drive URL).

export const PROJECTS = [
  {
    slug: "design-mumbai-2025",
    title: "Design Mumbai 2025",
    role: "Greenery Solutions Partner",
    year: "2025",
    date_label: "November 2025",
    venue: "Jio World Garden, BKC",
    city: "Mumbai",
    summary:
      "Indoor Greens was the Greenery Solutions Partner for Design Mumbai 2025 at Jio World Garden, BKC — one of India's most closely watched design showcases. Our team designed and installed the biophilic and green elements that framed the fair.",
    external_album_url: null,
    cover:
      "/media/design-mumbai/design-mumbai-cover.webp",
    body: [
      { type: "p", text:
        "In November 2025 we partnered with Design Mumbai — the country's leading contemporary design fair — as its official Greenery Solutions Partner. Held across the manicured lawns of Jio World Garden in BKC, the fair welcomed studios, galleries and thousands of visitors over its run." },
      { type: "p", text:
        "Our brief was to shape the horticultural language of the event: the arrival, the moments of pause between pavilions, and the quiet green punctuation that gives a design fair its texture. Every planter, tree and vertical composition was chosen and placed to belong to the space rather than sit inside it." },
      { type: "p", text:
        "Working alongside the Design Mumbai team, we curated a palette of luxury indoor and outdoor specimens, installed on-site, and maintained the plantings across the run of the show." },
    ],
    gallery: [
      {
        src: "/media/design-mumbai/design-mumbai-exchange.webp",
        caption:
          "A camellia standard in a gold-finish ceramic planter, its base carpeted with red anthuriums — placed beside the main event stage.",
      },
      {
        src: "/media/design-mumbai/indoor-greens-booth.webp",
        caption:
          "A glimpse of our stall at the event — a curation of our finest ceramic planters and select specimen plants, styled with seating from Wootique.",
      },
      {
        src: "/media/design-mumbai/most-loved-ceramics.webp",
        caption:
          "Two of the most loved ceramics from our collection — textural, hand-finished urns that anchored a corner of the stall.",
      },
    ],
    credits: [
      { label: "Event", value: "Design Mumbai 2025" },
      { label: "Venue", value: "Jio World Garden, BKC, Mumbai" },
      { label: "Date", value: "November 2025" },
      { label: "Our role", value: "Greenery Solutions Partner" },
    ],
  },
];

export const getProjectBySlug = (slug) =>
  PROJECTS.find((p) => p.slug === slug);
